/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_DisclaimerInputs */

const en_wc_footer_disclaimer = /** @type {(inputs: Wc_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraftApp is an independent English-language guide and online access point for WordCraft. WordCraft is developed by ArtCraft. We are not affiliated with ArtCraft or Microsoft. Microsoft Word is a trademark of Microsoft Corporation.`)
};

/**
* | output |
* | --- |
* | "WordCraftApp is an independent English-language guide and online access point for WordCraft. WordCraft is developed by ArtCraft. We are not affiliated with A..." |
*
* @param {Wc_Footer_DisclaimerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_disclaimer = /** @type {((inputs?: Wc_Footer_DisclaimerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_DisclaimerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_disclaimer(inputs)
});
export { wc_footer_disclaimer as "wc.footer.disclaimer" }